"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSG_RESPONSE = exports.MSG_REQUEST = exports.REQUEST_TRANSACTION = exports.REQUEST_TRANSACTION_STATUS = exports.REQUEST_CONNECTION = exports.REQUEST_NETWORK = exports.GEM_WALLET = void 0;
exports.GEM_WALLET = 'gem-wallet';
exports.REQUEST_NETWORK = 'REQUEST_NETWORK';
exports.REQUEST_CONNECTION = 'REQUEST_CONNECTION';
exports.REQUEST_TRANSACTION_STATUS = 'REQUEST_TRANSACTION_STATUS';
exports.REQUEST_TRANSACTION = 'REQUEST_TRANSACTION';
exports.MSG_REQUEST = 'GEM_WALLET_MSG_REQUEST';
exports.MSG_RESPONSE = 'GEM_WALLET_MSG_RESPONSE';
